// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactUs
{
    width: 70%;
    height: auto;
    margin: 2% 0 3% 25%;
}
.leftDiv
{
    width: 35%;
    height: 52vh;
    padding: 1%;
    background-color: #fff5f5;
    float: left;
}
.rightDiv
{
    width: 35%;
    height: auto;
    padding: 1%;
    background-color: #f7f5fa;
    float: left;
}
.contactHeading
{
    font-size: 20px;
    font-family: Verdana, Geneva, Tahoma, sans-serif;
    color: #3b3b53;
    text-align: center;
    margin: 0 0 3% 0;
    font-weight: bold;
}
.Input
{
    width: 90%;
    height: 30px;
    border: 1px solid rgb(175, 175, 175);
    border-radius: 1vh;
    margin: 2%;
    padding: 3%;
}
/*.cnt
{
    width: 90%;
    height: auto;
    
    margin: 2%;
    padding: 3%;
}*/
.Input:hover{
    border: 2px solid rgb(56, 56, 196)

}
.btnSend
{
    padding: 3% 6% 3% 6%;
    background-color: #03b4c6;
    font-weight: bold;
    color: white;
    font-family: sans-serif;
    border: 0;
    border-radius: 1vh;
    margin-left: 25%;
}
.FB:hover{
    color: #475993;
    cursor: pointer;
}
.TW:hover{
    color: #03a9f4;
    cursor: pointer;
}
.YT:hover{
    color: #c61b1f;
    cursor: pointer;
}
.IN:hover{
    color: #ea4653;
    cursor: pointer;
}
.PIN:hover{
    color: #cb2027;
    cursor: pointer;
}
.FB,.TW,.PIN,.IN,.YT{
    color: gray;
}

@media only screen and (max-width: 1000px)
{
    .contactUs{    
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-left: 0;
        align-items: center;
        justify-content: center;
    }
    .leftDiv,.rightDiv
    {
        width: -webkit-fill-available;
    }
}
`, "",{"version":3,"sources":["webpack://./src/MyComponents/FooterPages/ContactUs.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,YAAY;IACZ,mBAAmB;AACvB;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;AACf;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,WAAW;AACf;AACA;;IAEI,eAAe;IACf,gDAAgD;IAChD,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;IAEI,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;AACA;;;;;;;EAOE;AACF;IACI;;AAEJ;AACA;;IAEI,oBAAoB;IACpB,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;AACf;;AAEA;;IAEI;QACI,aAAa;QACb,sBAAsB;QACtB,WAAW;QACX,cAAc;QACd,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;;QAEI,6BAA6B;IACjC;AACJ","sourcesContent":[".contactUs\n{\n    width: 70%;\n    height: auto;\n    margin: 2% 0 3% 25%;\n}\n.leftDiv\n{\n    width: 35%;\n    height: 52vh;\n    padding: 1%;\n    background-color: #fff5f5;\n    float: left;\n}\n.rightDiv\n{\n    width: 35%;\n    height: auto;\n    padding: 1%;\n    background-color: #f7f5fa;\n    float: left;\n}\n.contactHeading\n{\n    font-size: 20px;\n    font-family: Verdana, Geneva, Tahoma, sans-serif;\n    color: #3b3b53;\n    text-align: center;\n    margin: 0 0 3% 0;\n    font-weight: bold;\n}\n.Input\n{\n    width: 90%;\n    height: 30px;\n    border: 1px solid rgb(175, 175, 175);\n    border-radius: 1vh;\n    margin: 2%;\n    padding: 3%;\n}\n/*.cnt\n{\n    width: 90%;\n    height: auto;\n    \n    margin: 2%;\n    padding: 3%;\n}*/\n.Input:hover{\n    border: 2px solid rgb(56, 56, 196)\n\n}\n.btnSend\n{\n    padding: 3% 6% 3% 6%;\n    background-color: #03b4c6;\n    font-weight: bold;\n    color: white;\n    font-family: sans-serif;\n    border: 0;\n    border-radius: 1vh;\n    margin-left: 25%;\n}\n.FB:hover{\n    color: #475993;\n    cursor: pointer;\n}\n.TW:hover{\n    color: #03a9f4;\n    cursor: pointer;\n}\n.YT:hover{\n    color: #c61b1f;\n    cursor: pointer;\n}\n.IN:hover{\n    color: #ea4653;\n    cursor: pointer;\n}\n.PIN:hover{\n    color: #cb2027;\n    cursor: pointer;\n}\n.FB,.TW,.PIN,.IN,.YT{\n    color: gray;\n}\n\n@media only screen and (max-width: 1000px)\n{\n    .contactUs{    \n        display: flex;\n        flex-direction: column;\n        width: 100%;\n        margin-left: 0;\n        align-items: center;\n        justify-content: center;\n    }\n    .leftDiv,.rightDiv\n    {\n        width: -webkit-fill-available;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
